import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";

import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

import ContactList from "../components/ContactList";
import PanelLayout from "../components/PanelLayout";
import { ListSkeleton } from "../components/Skeleton";

import * as actions_contact from "../redux/actions/contactsActions";
import * as actions_event from "../redux/actions/eventActions";
import "./styles/Contacts.css";

class Contacts extends React.Component {
  componentDidMount() {
    this.fetchContactList();
  }

  fetchContactList = async () => {
    try {
      await this.props
        .LoadContacts(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          } else {
            this.props.LoadContactsOnline(this.props.user_id, this.props.token);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <PanelLayout>
        <div className="contacts-page">
          <header className="contacts-page__header">
            <h1 className="contacts-page__title">
              <Translate value="contact_title" />
            </h1>
          </header>

          {this.props.loading ? (
            <ListSkeleton />
          ) : (
            <ContactList contactList={this.props.contactList} />
          )}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    contactList: reducer.contacts.list,
    error: reducer.contacts.error,
    loading: reducer.contacts.loading,
    pageCount: reducer.contacts.page_count,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadContacts: (user_id, token) =>
    dispatch(actions_contact.loadList({ user_id, token })),
  LoadContactsOnline: (user_id, token) =>
    dispatch(actions_event.loadContactsOnline({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
